import { GET_CONVERSATION_BY_CAMPAIGN, PROCESS_THE_FILE } from "../helpers/api-path";
import httpClient from "./http.interceptor";

const generateTranscriptAPI = async (conversation_id) => {
    return await httpClient.post(PROCESS_THE_FILE, {
        conversation_id,
        environment: process.env.REACT_APP_ENVIRONMENT,
    });
}

const getConversationListAPI = async (formData) => {
    return await httpClient.get(GET_CONVERSATION_BY_CAMPAIGN, {
        params: {
            ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
            ...formData
        }
    });
}

export {
    generateTranscriptAPI,
    getConversationListAPI
}